<!-- Template for warning/error SVG icon used in all three modes -->
<ng-template #warningIcon let-iconClass>
  <svg
    *ngIf="creditUsage?.peopleQuotaWarning !== null"
    [class]="iconClass"
    viewBox="0 0 486.463 486.463">
    <g>
      <g>
        <path
          [attr.fill]="creditUsage?.peopleQuotaWarning === 'error' ? 'var(--red-500)' : 'var(--warning-color)'"
          d="M243.225,333.382c-13.6,0-25,11.4-25,25s11.4,25,25,25c13.1,0,25-11.4,24.4-24.4
          C268.225,344.682,256.925,333.382,243.225,333.382z" />
        <path
          [attr.fill]="creditUsage?.peopleQuotaWarning === 'error' ? 'var(--red-500)' : 'var(--warning-color)'"
          d="M474.625,421.982c15.7-27.1,15.8-59.4,0.2-86.4l-156.6-271.2c-15.5-27.3-43.5-43.5-74.9-43.5s-59.4,16.3-74.9,43.4
          l-156.8,271.5c-15.6,27.3-15.5,59.8,0.3,86.9c15.6,26.8,43.5,42.9,74.7,42.9h312.8
          C430.725,465.582,458.825,449.282,474.625,421.982z M440.625,402.382c-8.7,15-24.1,23.9-41.3,23.9h-312.8
          c-17,0-32.3-8.7-40.8-23.4c-8.6-14.9-8.7-32.7-0.1-47.7l156.8-271.4c8.5-14.9,23.7-23.7,40.9-23.7c17.1,0,32.4,8.9,40.9,23.8
          l156.7,271.4C449.325,369.882,449.225,387.482,440.625,402.382z" />
        <path
          [attr.fill]="creditUsage?.peopleQuotaWarning === 'error' ? 'var(--red-500)' : 'var(--warning-color)'"
          d="M237.025,157.882c-11.9,3.4-19.3,14.2-19.3,27.3c0.6,7.9,1.1,15.9,1.7,23.8c1.7,30.1,3.4,59.6,5.1,89.7
          c0.6,10.2,8.5,17.6,18.7,17.6c10.2,0,18.2-7.9,18.7-18.2c0-6.2,0-11.9,0.6-18.2c1.1-19.3,2.3-38.6,3.4-57.9
          c0.6-12.5,1.7-25,2.3-37.5c0-4.5-0.6-8.5-2.3-12.5C260.825,160.782,248.925,155.082,237.025,157.882z" />
      </g>
    </g>
  </svg>
</ng-template>

<!-- Button Mode (Default) -->
<ng-container
  *ngIf="displayMode === 'button' && creditUsage?.peopleQuota && (!hideText || !hideProgressBar || creditUsage?.peopleQuotaWarning !== null)">
  <button
    type="button"
    (keydown)="handleKeydown($event)"
    [class]="transparentBackground ? 
      'tw-flex tw-flex-row tw-items-center tw-gap-3 tw-p-2 tw-rounded-lg dark:tw-text-white tw-cursor-pointer' : 
      'tw-flex tw-flex-row tw-items-center tw-gap-3 tw-bg-gray-200 dark:tw-text-white dark:tw-bg-gray-800 tw-p-2 tw-rounded-lg dark:hover:tw-bg-gray-900 focus:tw-outline-none tw-ring-2 tw-ring-gray-300 dark:tw-ring-gray-700 focus:tw-ring-3 focus:tw-ring-gray-400 dark:focus:tw-ring-gray-600 tw-cursor-pointer'"
    [matMenuTriggerFor]="popoverMenu">
    <span *ngIf="!hideText" class="tw-flex tw-items-center tw-gap-2">
      <img src="../../../assets/icons/creditsw.svg" class="ldt-logo tw-w-6" />
      Credits
    </span>

    <mat-progress-bar
      *ngIf="!hideProgressBar"
      class="tw-w-20"
      mode="determinate"
      [value]="creditUsage?.peopleUsagePercentage"></mat-progress-bar>

    <!-- warning or error icon -->
    <ng-container *ngTemplateOutlet="warningIcon; context: { $implicit: 'tw-h-4' }"></ng-container>
  </button>

  <!-- mat-menu as popover for button mode -->
  <mat-menu #popoverMenu="matMenu" class="credit-usage-popover" [overlapTrigger]="false">
    <div
      *ngIf="creditUsage?.peopleQuota"
      (click)="$event.stopPropagation()"
      class="popover-content tw-text-dark-light-dynamic tw-flex tw-flex-col tw-gap-3 tw-p-4">
      <button mat-icon-button class="tw-absolute tw-top-0 tw-right-0" (click)="closeMenu()">
        <mat-icon class="sm-close-icon">close</mat-icon>
      </button>

      <div class="tw-text-lg tw-font-semibold">Your account balance</div>

      <div>
        <span class="tw-font-bold">{{ creditUsage?.peopleUsage | number }} </span> of
        <span class="tw-font-bold">{{ creditUsage?.peopleQuota | number }}</span> credits used
        <span class="tw-ml-2">|</span>
        <span
          *ngIf="creditUsage?.peopleUsagePercentage"
          class="tw-text-base tw-font-bold tw-text-gray-600 dark:tw-text-gray-400 tw-ml-2">
          {{ creditUsage?.peopleUsagePercentage | number : '1.0-0' }}%
        </span>
      </div>

      <div
        class="tw-flex tw-items-center tw-gap-2 tw-text-sm tw-text-blue-800 tw-border tw-border-blue-300 tw-rounded-lg tw-bg-blue-50 dark:tw-bg-gray-700 dark:tw-text-gray-100 tw-p-2"
        role="alert">
        <mat-icon
          class="material-icons-outlined tw-flex-shrink-0 tw-inline tw-opacity-75 tw-text-gray-500 dark:tw-text-gray-400">
          schedule
        </mat-icon>
        <div>Monthly credits renew on {{ creditUsage?.resetDate | date:'MMM d':'UTC' }}.</div>
      </div>

      <button mat-stroked-button color="primary" (click)="goToBilling()">
        Plan & Billing Settings
      </button>
    </div>
  </mat-menu>
</ng-container>

<!-- Inline Mode (Direct display without button/popover) -->
<ng-container *ngIf="displayMode === 'inline' && creditUsage?.peopleQuota">
  <div
    class="tw-text-dark-light-dynamic tw-flex tw-flex-col tw-gap-3 tw-p-4 tw-bg-gray-100 dark:tw-bg-gray-800 tw-rounded-lg">
    <div class="tw-flex tw-items-center tw-gap-2">
      <img src="../../../assets/icons/creditsw.svg" class="ldt-logo tw-w-6" />
      <div class="tw-text-lg tw-font-semibold">Your account balance</div>

      <!-- Warning icon if applicable -->
      <ng-container
        *ngTemplateOutlet="warningIcon; context: { $implicit: 'tw-h-5 tw-ml-auto' }"></ng-container>
    </div>

    <div>
      <span class="tw-font-bold">{{ creditUsage?.peopleUsage | number }} </span> of
      <span class="tw-font-bold">{{ creditUsage?.peopleQuota | number }}</span> credits used
      <span *ngIf="pendingRecords > 0">
        <span class="tw-mx-1">+</span>
        <span class="tw-font-bold" [ngClass]="{ 'tw-text-red-500': wouldExceedQuota }">{{ pendingRecords | number }}</span>
        pending
      </span>
      <span class="tw-ml-2">|</span>
      <span
        *ngIf="creditUsage?.peopleUsagePercentage"
        class="tw-text-base tw-font-bold tw-text-gray-600 dark:tw-text-gray-400 tw-ml-2">
        {{ creditUsage?.peopleUsagePercentage | number : '1.0-0' }}%
      </span>
    </div>

    <!-- Enhanced Progress Bar -->
    <div
      class="tw-relative tw-w-full tw-h-4 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-overflow-hidden">
      <div
        class="tw-absolute tw-top-0 tw-left-0 tw-h-full tw-transition-all tw-duration-300 tw-rounded-full"
        [ngClass]="{
          'tw-bg-emerald-500': creditUsage?.peopleUsagePercentage < 70,
          'tw-bg-yellow-500': creditUsage?.peopleUsagePercentage >= 70 && creditUsage?.peopleUsagePercentage < 90,
          'tw-bg-red-500': creditUsage?.peopleUsagePercentage >= 90
        }"
        [style.width.%]="creditUsage?.peopleUsagePercentage"></div>
      <!-- Pending records hatched overlay -->
      <div
        *ngIf="pendingPercentage > 0"
        class="tw-absolute tw-top-0 tw-h-full tw-transition-all tw-duration-300 pending-bar tw-cursor-default"
        [ngClass]="{ 'pending-bar--exceed': wouldExceedQuota }"
        [style.left.%]="clampedUsagePercentage"
        [style.width.%]="pendingPercentage"
        [matTooltip]="'This download: ' + (pendingRecords | number) + ' credits'"
        matTooltipPosition="above"></div>
    </div>

    <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400 tw-flex tw-items-center tw-gap-2">
      <mat-icon
        class="material-icons-outlined tw-flex-shrink-0 tw-inline tw-opacity-75 tw-text-base tw-w-[18px]">
        schedule
      </mat-icon>
      Monthly credits renew on
      {{ creditUsage?.resetDate | date:'MMMM d, yyyy':'UTC' }}.
    </div>
  </div>
</ng-container>

<!-- Detailed Mode (More comprehensive display) -->
<ng-container *ngIf="displayMode === 'detailed' && creditUsage?.peopleQuota">
  <div
    class="tw-text-dark-light-dynamic tw-flex tw-flex-col tw-p-5 tw-bg-gray-50 dark:tw-bg-gray-800 tw-rounded-lg tw-shadow-md tw-border tw-border-gray-200 dark:tw-border-gray-700"
    [ngClass]="{'tw-gap-4': !isDetailCollapsed, 'tw-gap-0': isDetailCollapsed}">
    <!-- Alert for when no credit info is available -->
    <app-alert
      *ngIf="!creditUsage?.peopleQuota"
      [alertType]="AlertType.Warning"
      alertStyle="compact"
      [hasBorder]="false"
      [noBottomMargin]="true">
      Credit usage information is not available at this time. Please try again later.
    </app-alert>

    <!-- Main content - only show if credit info is available -->
    <ng-container *ngIf="creditUsage?.peopleQuota">
      <div class="tw-flex tw-items-center tw-justify-between">
        <div
          class="tw-flex tw-items-center tw-gap-3 tw-cursor-pointer"
          (click)="toggleDetailCollapse()"
          role="button"
          aria-expanded="!isDetailCollapsed"
          tabindex="0"
          (keydown.enter)="toggleDetailCollapse()"
          (keydown.space)="toggleDetailCollapse(); $event.preventDefault()">
          <img src="../../../assets/icons/creditsw.svg" class="ldt-logo tw-w-8" />
          <div class="tw-text-xl tw-font-bold">Credit Balance</div>
          <mat-icon
            class="tw-transition-transform tw-duration-300 tw-text-[30px] tw-leading-[26px]"
            [ngClass]="{'tw-rotate-180': isDetailCollapsed}">
            expand_more
          </mat-icon>
        </div>

        <!-- Warning icon if applicable -->
        <ng-container
          *ngTemplateOutlet="warningIcon; context: { $implicit: 'tw-h-6' }"></ng-container>
      </div>

      <!-- Collapsible content with animation -->
      <div
        class="tw-overflow-hidden tw-transition-all tw-duration-1000"
        [ngClass]="{'tw-max-h-0 tw-opacity-0 tw-mt-0': isDetailCollapsed, 'tw-max-h-[500px] tw-opacity-100': !isDetailCollapsed}">
        <div class="tw-flex tw-justify-between tw-items-end">
          <div>
            <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">Credits Used</div>
            <div class="tw-text-2xl tw-font-bold">{{ creditUsage?.peopleUsage | number }}</div>
          </div>
          <div>
            <div class="tw-text-sm tw-text-gray-500 dark:tw-text-gray-400">Total Credits</div>
            <div class="tw-text-2xl tw-font-bold">{{ creditUsage?.peopleQuota | number }}</div>
          </div>
        </div>

        <!-- Enhanced Progress Bar with Labels -->
        <div class="tw-mt-2">
          <div
            class="tw-relative tw-w-full tw-h-6 tw-bg-gray-200 dark:tw-bg-gray-700 tw-rounded-full tw-overflow-hidden">
            <div
              class="tw-absolute tw-top-0 tw-left-0 tw-h-full tw-transition-all tw-duration-300 tw-rounded-full tw-flex tw-items-center tw-justify-end tw-pr-2"
              [ngClass]="{
                'tw-bg-emerald-500': creditUsage?.peopleUsagePercentage < 70,
                'tw-bg-yellow-500': creditUsage?.peopleUsagePercentage >= 70 && creditUsage?.peopleUsagePercentage < 90,
                'tw-bg-red-500': creditUsage?.peopleUsagePercentage >= 90
              }"
              [style.width.%]="creditUsage?.peopleUsagePercentage">
              <span
                *ngIf="creditUsage?.peopleUsagePercentage > 10"
                class="tw-text-white tw-text-xs tw-font-bold tw-inline-block tw-pr-2">
                {{ creditUsage?.peopleUsage | number }}
              </span>
            </div>
            <!-- Pending records hatched overlay -->
            <div
              *ngIf="pendingPercentage > 0"
              class="tw-absolute tw-top-0 tw-h-full tw-transition-all tw-duration-300 pending-bar tw-cursor-default"
              [ngClass]="{ 'pending-bar--exceed': wouldExceedQuota }"
              [style.left.%]="creditUsage?.peopleUsagePercentage"
              [style.width.%]="pendingPercentage"
              [matTooltip]="'This download: ' + (pendingRecords | number) + ' credits'"
              matTooltipPosition="above"></div>
          </div>
        </div>

        <app-alert
          [alertType]="creditUsage?.peopleQuotaWarning === 'error' ? AlertType.Error : 
                      creditUsage?.peopleQuotaWarning === 'warn' ? AlertType.Warning : 
                      AlertType.Info"
          alertStyle="compact"
          [noBottomMargin]="true"
          [hasBorder]="false"
          class="tw-mt-4">
          <span class="tw-font-medium">
            Monthly credits renew on
            {{ creditUsage?.resetDate | date:'MMMM d, yyyy':'UTC' }}.
          </span>
          <span *ngIf="creditUsage?.peopleQuotaWarning === 'warn'" class="tw-block tw-mt-1">
            You're approaching your credit limit. Consider upgrading your plan.
          </span>
          <span *ngIf="creditUsage?.peopleQuotaWarning === 'error'" class="tw-block tw-mt-1">
            You've nearly reached your credit limit. Upgrade now to continue using all features.
          </span>
        </app-alert>

        <!-- Billing button -->
        <!-- Bring this back when we have a people purchase modal that can pop up -->
        <!-- <button
          *ngIf="creditUsage?.peopleQuotaWarning === 'error' || creditUsage?.peopleQuotaWarning === 'warn'"
          mat-stroked-button
          color="primary"
          (click)="navigateToSettings()"
          class="tw-mt-4">
          Plan & Billing Settings
        </button> -->
      </div>
    </ng-container>
  </div>
</ng-container>
